export default [
  [`Размеры`, `S`, `M`, `L`, `XL`],
  [`Российский размер`, `44-46`, `46-48`, `48-50`, `50-52`],
  [`Полуобхват груди`, `63`, `65`, `67`, `69`],
  [`Длина изделия`, `73`, `74`, `76`, `79`],
  [`Длина рукава`, `26`, `27`, `28`, `30`]
];
